import axios from "axios";
//htis is api
const Client = axios.create({
  // baseURL: "http://localhost:8000",
  baseURL:"https://saasphirebackend.vercel.app",
  withCredentials: true,
});

export default Client;
